export const site = {  
  data() {
    return {
      image_path: `/assets/image/`,
      siteConfig: null,
      default_config: {
        websocket_port: 5000,
        title: "AVRO ERP",
        name: "(주)아브로소프트코리아",
        addr: "서울 마포구 월드컵북로 396 누리꿈스퀘어 연구개발타워 607-4호",
        tel: "02-2132-5115",
        fax: "02-2132-5114",
        bank: "하나 160910-10-794307",
        owner: "신종화",
        email: "hwa7132@naver.com",
        crn: "230-88-00730",
        conditions: "서비스",
        item: "소프트웨어 개발 및 공급",
      },
    }
  },
  computed: {
    siteLogoPath() {
      return this.image_path + 'logo.png';
    },
    siteStampPath() {      
      return this.isExistImageFile('stamp.png')? this.image_path + 'stamp.png': '';
    },
    siteTitle() {
      return this.$store.getters.title;
    }
  },
  methods: {
    readFile(filename) {
      try {
        let file = require(`../../../public/assets${filename}`);
        return file;
      } catch {
        return false;
      }
    },
    isExistImageFile(filename) {
      return this.readFile('/image/' + filename);
    },
  }
}